import { useQuery } from "@tanstack/react-query";
import { api } from "../../config";

function useGetSkus(params, enabl) {
  return useQuery({
      queryFn: async () => {
          const res = await api.get(`/marketplace/skus/list/paged`, {params});
          return res.data;
      },
      queryKey: ['paged-skus'],
      enabled: enabl,
      retry: false,
      refetchOnWindowFocus: false
  })
}

export { useGetSkus };